import { SystemParameters } from '../models/system-parameters.model';

export const SYSTEM_PARAMETERS_HIDDEN_FIELDS = [
    SystemParameters.PRODUCT_PARENT_UID,
    SystemParameters.CATEGORYCODE,
    SystemParameters.UNITCODE,
    SystemParameters.STATUS,
    SystemParameters.TIME_ZONE
];
